"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonVariants = exports.ButtonThemes = exports.ButtonTags = exports.ButtonSizes = exports.Button = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon = require("../Icon");
var _excluded = ["checked", "children", "className", "controlRef", "disabled", "fullWidth", "innerRef", "size", "style", "tag", "theme", "variant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
require("./Button.css");
var styles = {
  "Root": "Button-module-Root_wsW",
  "Text": "Button-module-Text_1-J",
  "hasOneIcon": "Button-module-hasOneIcon_3oC",
  "sSize": "Button-module-sSize_24u",
  "mSize": "Button-module-mSize_uvb",
  "lSize": "Button-module-lSize_2C6",
  "hasOnlyText": "Button-module-hasOnlyText_1Mm",
  "hasIconAndText": "Button-module-hasIconAndText_225",
  "fullWidth": "Button-module-fullWidth_dw-",
  "primaryTheme": "Button-module-primaryTheme_2Rz",
  "lightTheme": "Button-module-lightTheme_7ED",
  "neutralTheme": "Button-module-neutralTheme_2sv",
  "outlinedSolidVariant": "Button-module-outlinedSolidVariant_17K",
  "outlinedDashedVariant": "Button-module-outlinedDashedVariant_3op",
  "transparentTheme": "Button-module-transparentTheme_3Pr"
};
var ButtonThemes = {
  primary: 'primary',
  light: 'light',
  neutral: 'neutral',
  transparent: 'transparent'
};
exports.ButtonThemes = ButtonThemes;
var ButtonVariants = {
  filled: 'filled',
  outlinedSolid: 'outlinedSolid',
  outlinedDashed: 'outlinedDashed'
};
exports.ButtonVariants = ButtonVariants;
var ButtonSizes = {
  s: 's',
  m: 'm',
  l: 'l'
};
exports.ButtonSizes = ButtonSizes;
var ButtonTags = {
  a: 'a',
  button: 'button'
};
exports.ButtonTags = ButtonTags;
var Button = function Button(_ref) {
  var _children$, _cn;
  var checked = _ref.checked,
    children = _ref.children,
    className = _ref.className,
    controlRef = _ref.controlRef,
    disabled = _ref.disabled,
    fullWidth = _ref.fullWidth,
    innerRef = _ref.innerRef,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? ButtonSizes.m : _ref$size,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? ButtonTags.button : _ref$tag,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? ButtonThemes.primary : _ref$theme,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? ButtonVariants.filled : _ref$variant,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var Component = tag;
  var rootProps = _objectSpread({}, props);
  if (tag === ButtonTags.button) {
    var _ref2 = props,
      name = _ref2.name;
    rootProps.disabled = Boolean(disabled);
    rootProps.type = props.type || 'button';
    Boolean(name) && (rootProps.name = name);
  }
  if (tag === ButtonTags.a) {
    /** @see {@link https://www.scottohara.me/blog/2021/05/28/disabled-links.html} */
    if (disabled) {
      rootProps.href = undefined;
      rootProps.role = 'link';
    }
  }
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    ref: innerRef || controlRef,
    className: (0, _classnames.default)(styles.Root, (_cn = {}, (0, _defineProperty2.default)(_cn, styles.fullWidth, fullWidth), (0, _defineProperty2.default)(_cn, styles.hasOneIcon, !Array.isArray(children) && (children === null || children === void 0 ? void 0 : children.type) === _Icon.Icon), (0, _defineProperty2.default)(_cn, styles.hasOnlyText, !Array.isArray(children) && typeof children === 'string'), (0, _defineProperty2.default)(_cn, styles.hasIconAndText, Array.isArray(children) && children.length === 2 && (((_children$ = children[1]) === null || _children$ === void 0 ? void 0 : _children$.type) === _Icon.Icon || typeof children[1] === 'string')), _cn), styles["".concat(theme, "Theme")], styles["".concat(variant, "Variant")], styles["".concat(size, "Size")], className),
    style: style
  }, disabled && (0, _defineProperty2.default)({}, tag === ButtonTags.button ? 'disabled' : 'aria-disabled', disabled), checked && {
    'aria-pressed': checked
  }, rootProps), _react.Children.map(children, function (child) {
    return typeof child === 'string' ? /*#__PURE__*/_react.default.createElement("div", {
      className: styles.Text
    }, child) : child;
  }));
};
exports.Button = Button;
if (process.env.NODE_ENV !== 'production') {
  Button.displayName = 'Button';
}